import Coloris from "@melloware/coloris";
import Toastify from 'toastify-js'

const updateStudent = () => {

  // get the student form
  let form = document.getElementById("update_student_form");

  // check if the form exists in the DOM
  if (form) {

    // initialise
    Coloris.init();

    // update all avatar elements on input change
    document.addEventListener('coloris:pick', event => {
      let elem = '.' + event.detail.currentEl.id.replace("colour_", "");
      //console.log(event.detail);
      document.querySelectorAll(elem).forEach(el => el.style.fill = event.detail.color);
    });

    // create color picker elements
    Coloris({
      el: '.color-fields',
      alpha: false,
      swatchesOnly: false,
      defaultColor: '#ffffff',
      format: "hex"
    });

    // accents
    Coloris.setInstance('.instance1', { 
      alpha: false,
      swatchesOnly: true,
      format: "hex",
      swatches: [
        '#D00E00',
        '#F17B0E',
        '#F1BF0E',
        '#B9D31A',
        '#69B50A',
        '#14CB5D',
        '#08C8BC',
        '#17A8E7',
        '#0772D6',
        '#834EF3',
        '#BD26E3',
        '#F347C3',
        '#FF5588',
        '#2D2A2A'
      ]
    });

    // create submit event listener
    form.addEventListener("submit", (ev) => {
      
      // Prevent form submission
      ev.preventDefault();

      // Get form data
      const data = new FormData(form);
      data.append("action", "update_student");
      //console.log([...data]);

      // Make the AJAX request
      fetch("/wp-admin/admin-ajax.php", {
        method: "POST",
        body: data,
      })
        .then((response) => response.json())
        .then((response) => {
          // Handle the response
          //console.log(response.data);
          Toastify({
            text: response.data.message,
            duration: 2000,
            gravity: "bottom",
            position: "right",
            className: "rounded-md shadow", 
            style: { background: "#000000" }
          }).showToast();
        })
        .catch((error) => {
          // Handle any errors
          console.error(error);
        });
    });
  }

};

export { updateStudent };
